<template>
  <div>
    <form id="formulario">
      <h2 id="title_login">Quero criar minha conta</h2>
      <div id="insertpage">
        <p>E-mail:</p>
        <input type="message" v-model="email" placeholder />
      </div>
      <div id="insertpage">
        <p>Nome:</p>
        <input type="message" v-model="nome" placeholder />
      </div>
      <div id="insertpage">
        <p>Sobrenome:</p>
        <input type="message" v-model="sobrenome" placeholder />
      </div>
      <div id="insertpage">
        <p>Telefone:</p>
        <the-mask :mask="['(##) #####-####']" v-model="telefone" />
      </div>
      <div id="insertpage">
        <p>Senha:</p>
        <input type="password" v-model="senha" placeholder />
      </div>
      <div id="insertpage">
        <p>Confirmar senha:</p>
        <input type="password" v-model="confirmar_senha" placeholder />
      </div>
      <p v-if="error_message" id="error_message">{{error_message}}</p>
      <button type="button" v-on:click="cadastrar()">Cadastrar</button>
    </form>
  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask';
export default {
  name: "CadastrarUser",
  components: {TheMask},
  data() {
    return {
      email: "",
      nome: "",
      sobrenome: "",
      telefone: "",
      senha: "",
      confirmar_senha: "",
      cpf: "",
      error_message: ""
    };
  },
  mounted() {
    let email = this.$route.query.e;
    if (!(email.includes("@") && email.includes("."))) {
      this.$router.push("/login");
    } else {
      this.email = email;
    }
  },
  methods: {
    async cadastrar() {
      if (
        this.email &&
        this.nome &&
        this.sobrenome &&
        this.telefone &&
        this.senha &&
        this.confirmar_senha
      ) {
        if (this.senha && this.confirmar_senha) {
          if (this.email.includes("@") && this.email.includes(".")) {
            let dados = {
              email: this.email,
              senha: this.senha
            };

            let dados2 = {
              nome: this.nome,
              sobrenome: this.sobrenome,
              telefone: this.telefone
            };

            let retorno = null;
            await this.$http
              .post(`/projects/register-client`, dados)
              .then(res => {
                retorno = res.data;
                let save = JSON.stringify(res.data);
                localStorage.setItem("usuario", save);

                dados2.user = res.data.user._id;
              })
              .catch(err => (this.error_message = err.error));
            await this.$http
              .post(`/projects/cliente`, dados2)
              .then(res2 => {
                retorno.cliente = res2.data.cliente;
                let save = JSON.stringify(retorno);
                localStorage.setItem("usuario", save);
                this.$router.push("/account");
              })
              .catch(err => (this.error_message = err.error));
          } else {
            this.error_message = "E-mail inválido";
          }
        } else {
          this.error_message = "Senhas diferentes";
        }
      } else {
        this.error_message = "Todos os campos são obrigatórios";
      }
    }
  }
};
</script>

<style>
#formulario {
  margin: 0 auto;
  align-items: center;
  justify-items: center;
}

#insertpage {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

#insertpage p {
  width: 300px;
  margin-right: 20px;
  margin-top: 10px;
  text-align: right;
}

#error_message {
  color: red;
  font-size: 12px;
  margin-top: 15px;
}

@media screen and (max-width:800px){
  #insertpage p {
  width: 100px;
  margin-right: 20px;
  margin-top: 10px;
  text-align: right;
  }

  #insertpage input{
    width: 50%;
  }
}
</style>